var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow---Non-PD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-profile-scrolled-to-insurance",
    transform: "translate(-146.000000, -127.000000)",
    fill: "#E3215F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(15.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139,22 C134.591111,22 131,25.5911111 131,30 C131,34.4088889 134.591111,38 139,38 C143.408889,38 147,34.4088889 147,30 C147,25.5911111 143.408889,22 139,22 Z M140.12,35.2088889 L137.88,35.2088889 L137.88,27.9555556 L140.137778,27.9555556 L140.137778,35.2088889 L140.12,35.2088889 Z M138.982222,27.0666667 C138.271111,27.0666667 137.791111,26.5688889 137.808889,25.9466667 C137.791111,25.2888889 138.271111,24.8088889 139,24.8088889 C139.728889,24.8088889 140.191111,25.3066667 140.208889,25.9466667 C140.208889,26.5511111 139.728889,27.0666667 138.982222,27.0666667 Z",
    id: "info"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.072e84a37b2b732207397a16fe88ffe6.svg";
export { ForwardRef as ReactComponent };